<template>
    <transition name="fade">
        <div class="popup-overlay"
             v-if="loadingOverlayStateStore.state.show">
            <div class="content-frame">
                <div class="loading-circular">
                    <div style="transform:rotate(-90deg)">
                        <svg height="100%" viewBox="0 0 20 20" width="100%" style="overflow: visible;">
                            <circle cx="50%"
                                    cy="50%"
                                    fill="none"
                                    stroke-width="2"
                                    r="9"
                                    stroke="gray"
                                    stroke-linecap="square"
                                    style="stroke-dashoffset: 9; stroke-dasharray: 9;"/>
                        </svg>
                    </div>
                </div>
                <div class="message"
                     :style="{fontSize: FontSizes.large1}">{{ message }}</div>
            </div>
        </div>
    </transition>
</template>

<script lang="ts">

import {defineComponent, nextTick, ref} from "vue";
import {loadingOverlayStateStore} from "@/stores/loading-overlay-state-store";
import {FontSizes} from "@/utils/font-sizes";

export default defineComponent({
    name: "LoadingOverlay",
    setup() {

        const message = ref<string>("")

        loadingOverlayStateStore.watch(state => state.message, msg => {
            message.value = msg
        })

        return {
            loadingOverlayStateStore,
            message,
            FontSizes,
        }
    }
})
</script>

<style scoped lang="scss">

.fade-enter-active,
.fade-leave-active {
    /* 表示されている際のCSSはこのブロックに記述 */
    transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
    /* 非表示の際のCSSはこのブロックに記述 */
    opacity: 0;
}

.popup-overlay {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 2000;

    .content-frame {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 200px;
        height: 200px;

        .loading-circular {
            position: absolute;
            width: 150px;
            height: 150px;
            left: 25px;
            top: 0;
            animation: r1 2s linear infinite;
            opacity: 0.5;
        }

        .message {
            position: absolute;
            left: 0;
            right: 0;
            width: 200px;
            height: 10vw;
            text-align: center;
            bottom: 0;
            color: dimgrey;
        }

    }

}

@keyframes r1 {
    0%   { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

</style>